import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';

const fetchDefault = (payload) => (dispatch) => {
    ApiService.post(Path.MOBILE_CONTACT_GET_LIST, payload)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
        }).catch(()=>{
            dispatch(Actions.setList([])); 
        })
};

const getUnreadCount = (payload) => (dispatch) => {
    ApiService.post(Path.MOBILE_CONTACT_GET_UNREAD, payload)
        .then((response) => {
            dispatch(Actions.setUnread(response.data.data));
        })
};

const viewContact = (payload) => () => {
    return ApiService.post(Path.MOBILE_CONTACT, payload)
        .then((response) => {
            return response.data;
        })
};

const updateStatus = (payload) => () =>{
    return ApiService.post(Path.MOBILE_CONTACT_UPDATE_READ, payload)
        .then((response) => {
            return response.data;
        })
}

const deleteContact = (payload) => () => {
    return ApiService.post(Path.CONTACT_DELETE, payload)
        .then((response) => {
            return response.data;
        })
};

export {
    fetchDefault,
    getUnreadCount,
    viewContact,
    updateStatus,
    deleteContact
};
